var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-475 -1165)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M483.556 1167.85l-.854 7.883h-5.394l-.854-7.883zm-2.317-1.573v.786h-2.478v-.786zm-5.886 1.573h.387l.904 8.309a.36.36 0 0 0 .353.341h6.006c.181 0 .327-.142.353-.341l.904-8.31h.387c.198 0 .353-.17.353-.388s-.155-.388-.353-.388h-2.702v-1.185c0-.217-.155-.388-.353-.388h-3.184c-.198 0-.353.17-.353.388v1.185h-2.702c-.198 0-.353.17-.353.388s.164.389.353.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M478.5 1174.5c.28 0 .5-.188.5-.43v-5.14c0-.242-.22-.43-.5-.43s-.5.188-.5.43v5.14c0 .242.22.43.5.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M481.5 1174.5c.28 0 .5-.188.5-.43v-5.14c0-.242-.22-.43-.5-.43s-.5.188-.5.43v5.14c0 .242.232.43.5.43z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.7e717f7f.svg";
export { ForwardRef as ReactComponent };